import React from 'react';
//import PropTypes from 'prop-types';

import { Button, Typography } from '@material-ui/core';

import { getValue, setValue } from '_core/utils/storage';
import { useGlobal } from '_core/hooks/useGlobal';
import { withLang } from '_core/hocs/withLang';
import { ModalInner } from '_core/components/ModalInner';
import { ModalOuter } from '_core/components/ModalOuter';
import HtmlView from '_core/components/HtmlView';


const RawGreetingsSplash = (props) => {
  const {
    path,
    getLangString: l
  } = props;
  
  const {
    request: { queue },
    config: {
      API_METHOD,
      COOKIES_KEY
    }
  } = useGlobal();
  
  const [isOpen, setIsOpen] = React.useState();
  const [article, setArticle] = React.useState();
  
  if (path && isOpen === undefined) {
    setIsOpen(false);
    
    if (getValue(COOKIES_KEY.SPLASH) !== 1) {
      setTimeout(() => {
        queue(API_METHOD.ARTICLE_INFO, { path })
          .then((data) => { setArticle(data); setValue(COOKIES_KEY.SPLASH, 1); setIsOpen(true); })
          .catch((error) => console.error(error));
      }, 500);
    }
  }
  
  return (
    <ModalOuter closeIcon open={isOpen} onClose={(event) => setIsOpen(false)}>
      <ModalInner
        title={article?.title}
        content={
          <Typography variant="body1">
            <HtmlView>
              {article?.content}
            </HtmlView>
          </Typography>
        }
        actions={
          <Button onClick={(event) => setIsOpen(false)}>
            {l('r._.splash.greetings.control.ok')}
          </Button>
        }
      />
    </ModalOuter>
  );
};

RawGreetingsSplash.defaultProps = {};

RawGreetingsSplash.propTypes = {};

export const GreetingsSplash = withLang(RawGreetingsSplash);
